<template>
    <div class="bj2">
                    <!-- <div class="introduce-box introduce-boxssss" style="margin-top:0px;justify-content: center;height:35px;">
                        <h2 class="loi" style="margin-top:0px; font-size:40px" >合作品牌</h2>
                    </div> -->
                    <div class="hezuo hezuosss">
                        <div class="hezuo-box" style=" width: 120px;
                                  height: 1px;background: linear-gradient(to left,#C09255,black);"></div>
                        <div class="hezuo-wen" style="font-size:17px font-weight: 500;
                                  color: #FFFFFF;">合作品牌</div>
                        <div class="hezuo-box2" style="width: 120px;
                            height: 1px;
                            background:linear-gradient(to right,#C09255,black);"></div>
                    </div>
                    <div class="dui-box22" >
                          <div  class="pinwei-wen2s" style=" height: 14px; font-size: 14px;"  v-for="(item,index) in lists" :key="index">{{item}}</div>
                    </div>
                    <!-- <div class="hezuo ">
                        <div class="hezuo-box22" style=" width: 120px;
 height: 1px;background: linear-gradient(to left,#C09255,black);"></div>
                        <div class="hezuo-wen" style="font-weight: 500;
color: #FFFFFF;">媒体支持</div>
                        <div class="hezuo-box222" style="width: 120px;
 height: 1px;
 background:linear-gradient(to right,#C09255,black);"></div>
                    </div>
                    <div class="dui-box1" style=" center;height: 80px;">
                      <div  class="pinwei-wen2s" style=" height: 14px; font-size: 14px;" v-for="(item,index) in list" :key="index">{{item}}</div>
                    </div> -->
                    <div class="jiewei" style="font-size: 16px;">
                      最终解释权归主办方所有
                    </div>
                    <!-- <div class="kli"></div> -->
              <!-- 大赛进程 -->
              <!-- 大赛进程结束 -->
            </div>
</template>
<script>
export default {
  name: 'activity',
  data () {
    return {
      list:['人民日报数字四川','人民日报文创','人民网','新华社四川分社','中新社四川分社','中国网四川分社','四川电视台','四川日报','四川在线','川报观察','华西都市报','封面新闻','四川发布','腾讯大成网','新浪四川','搜狐','今日头条','四川文产'],
      lists:['合景·摩方（成都）','蜀之源酒业','高淳陶瓷','茂县羌绣' ,'拙品','北川巴拿恰文创','鹃城牌郫县豆瓣','宽厚'],
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>
<style scoped>
.introduce-boxssss{
padding-top:94px
}
.bj2{
 background: url(../image/weibu.gif) no-repeat center;
  /* background-size:100% 100%; */
  padding-bottom: 100px;
  background-size: cover;

}
.kli{
  /* margin-top: 168px; */
  height: 128px;
}
.jiewei{
  font-weight: 500;
color: #C09255;
  font-size: 24px;
  /* margin-bottom: 160px; */
  margin-top: 12px;
  display: flex;
    justify-content: center;
}
.pinwei-wen2s{
  border-right:1px solid #C6C6C6 ;
  padding-right:20px;
  padding-left:20px;
  font-size: 28px;
  margin-bottom: 15px;
  display: flex;
    align-items: center;
    font-weight: 400;
color: #FFFFFF;
   
}
 .pinwei-wen2s:last-child{
 border:none
}
 /* .pinwei-wen2s:nth-child(6){
 border:none
} */
.dui-box22{
   display: flex;
  align-items: center;
justify-content: center;

  /* padding-right: 501px; */
  /* width: 40%; */
  margin: auto;
 /* justify-content: space-between; */
 margin-bottom: 71px;
 flex-flow: wrap;

}
.dui-box1{
   display: flex;
  align-items: center;
  padding-left: 74px;
  /* padding-right: 501px; */
  /* width: 40%; */
  margin: auto;
 /* justify-content: space-between; */
 margin-bottom: 71px;
 flex-flow: wrap;
 width: 744px;
}

.duix{
  display: flex;
  align-items: center;
  /* width: 66%;
  margin: auto; */
  /* justify-content: space-between; */
}
.duix-box{
  /* color: #3F8068; */
   padding-right: 58px;
    /* padding-left: 68px; */
    height: 30px;
    width: 1px;
    /* background: yellow; */
    border-right:1px solid #C09255 ;
}
 .duix:last-child .duix-box{
 border:none
}
.duix-imgs{
  width: 84px;
  height: 80px;
}
.hezuo{
  display: flex;
  align-content: center;
  /* background: yellow; */
  /* margin-top: 10px; */
  justify-content: center;
    align-items: center;
    margin-bottom: 70px;
}
.hezuosss{
  padding-top:88px !important;
  font-weight: 500 !important;
color: #FFFFFF !important;
}
.hezuo-wen{
color: #3E514F;
font-size: 30px;
padding-left: 26px;
padding-right: 26px;
}
.hezuo-box{
 width: 170px;
 height: 1px;
 /* border-top: 0.5px solid #7CA4A0; */
}
h2{
  margin-top: 40px !important;
}
.loi{
  /* width: 350px;
  padding-left: 32px;
  padding-right: 32px;
  font-size: 60px; */
  font-weight: 400;
  color: #FFFFFF;
}
.introduce-box{
  display: flex;
  justify-content: space-between;
  margin: auto;
  /* background: red; */
  align-items: center;
 /* max-width: 470px; */
  margin-top: 129px;
  /* padding-left: 652px;
  padding-right: 610px; */
}
.body-box-imgs{
  width: 189px;
  height: 78px;
}
</style>


// WEBPACK FOOTER //
// src/components/head.vue